export default class JoinFormSupport {
  init() {
    this.usernameInput = document.getElementById("js-join-form-input-username");
    this.nicknameInput = document.getElementById("js-join-form-input-name");
    this.usernameInput.addEventListener("keyup", this.checkChangeValue());
  }

  checkChangeValue() {
    let prevUsername = "";

    // initElemの値が変更になったかどうか判定する関数を返す
    return () => {
      const currentUsername = this.usernameInput.value;
      if (currentUsername === prevUsername) {
        return;
      }
      if (this.nicknameInput.value === prevUsername) {
        this.nicknameInput.value = currentUsername;
      }
      prevUsername = currentUsername;
    };
  }
}
